<template>
    <div style="background-color: #e8e9ebe3;margin-top: -50px;height: 100vh;">
        <div style="padding:1vh 20px 0">
            <div class="index" :style="th"> 
                <el-row :gutter="20">
                    <el-col :span="12" class="item" style="height:45vh">
                        <div class="itemInfo" id="chart1">
                           <div class="title"><span><h5>床位统计</h5></span></div>
                           <el-row style="margin: 5px 20px">
                                <el-col :span="24" style="padding:0 10px;position: relative;">
                                    <div id="chartPie" style="height:250px;width:100%"></div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                    <el-col :span="12" class="item" style="height:45vh">
                        <div class="itemInfo">
                            <div class="title"><span><h5>在住长者等级护理统计</h5></span></div>
                            <el-row style="margin: 5px 20px">
                                <el-col :span="24" style="padding:0 10px;position: relative;">
                                    <div id="chartPie1" style="height:250px;"></div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                    <el-col :span="12" class="item" style="height:46vh">
                        <div class="itemInfo">
                            <div class="title"><span><h5>在住长者年龄分布</h5></span></div>
                            <el-row style="margin: 5px 20px">
                                <el-col :span="24" style="padding:0 10px">
                                    <div id="chartPie2" style="height:250px;"></div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                    <el-col :span="12" class="item" style="height:46vh">
                        <div class="itemInfo">
                            <div class="title"><span><h5>在住长者性别分布</h5></span></div>
                            <el-row style="margin: 5px 20px">
                                <el-col :span="24" style="padding:0 10px">
                                    <div id="chartPie3" style="height:270px;"></div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                    </el-row>
            </div>
        </div>
        <div>

        </div>
    </div>
</template>


<script>
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import echarts from 'echarts'
import {getStaffCode} from "@/utils/auth";
export default {
    data(){
        return{
            chartPie: null,
            chartPie1: null,
            chartPie2: null,
            chartPie3: null
        }
    },
    
    methods: {                               
            drawPieChart() {
                this.chartPie = echarts.init(document.getElementById('chartPie'));
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Statistics/BerthStatus",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then((res) => {
                    this.chartPie.setOption({
                        title: {
                            subtext: '',
                            x: 'center'
                        },
                        tooltip: {//提示框组件
                            trigger: 'item',//触发类型，在饼形图中为item
                            formatter: "{a} <br/>{b} : {c} ({d}%)"//提示内容格式
                        },
                        legend: {//图例
                            top: 'top',
                            data: ['已预订', '已入住', '空闲']
                        },
                        series: [//数据系列
                            {
                                name: '套餐预约占比',
                                type: 'pie',//饼形图
                                radius: '55%',
                                center: ['50%', '60%'],
                                data: [({ 'name':'已预订','value':res.data.data.已预订,itemStyle:{color:"#5a97e7"} }),
                                        ({ 'name':'已入住','value':res.data.data.已入住,itemStyle:{color:"#0bb457"} }),
                                        ({ 'name':'空闲','value':res.data.data.空闲 ,itemStyle:{color:"#9a9b9c"} })],
                                itemStyle: {
                                    emphasis: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    },
                                    normal:{ 
                                label:{ 
                                    show: true, 
                                    formatter: '{b} : {c} ({d}%)' 
                                }, 
                                labelLine :{
                                    show:true
                                } 
                            }
                                }
                            }
                        ]
                    });
                });
            },
            drawPie1Chart() {
                this.chartPie1 = echarts.init(document.getElementById('chartPie1'));
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Statistics/NursingStatus",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then((res) => {
                    // var list = res.data.data[0];


                    var typePie1=[]
                    var typePie4=[]
                    for(var i = 0; i < res.data.data.length; i++) {
                        typePie4.push(res.data.data[i].name)
                        typePie1.push({ 'name':res.data.data[i].name,'value':res.data.data[i].count })
                    }
                    
                    
                    
                    this.chartPie1.setOption({
                        title: {
                            subtext: '',
                            x: 'center'
                        },
                        tooltip: {//提示框组件
                            trigger: 'item',//触发类型，在饼形图中为item
                            formatter: "{a} <br/>{b} : {c} ({d}%)"//提示内容格式
                        },
                        legend: {//图例
                            top: 'top',
                            data: typePie4,
                        },
                        series: [//数据系列
                            {
                                name: '套餐预约占比',
                                type: 'pie',//饼形图
                                radius: '55%',
                                center: ['50%', '60%'],
                                data: typePie1,
                                itemStyle: {
                                    emphasis: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    },
                                    normal:{ 
                                label:{ 
                                    show: true, 
                                    formatter: '{b} : {c} ({d}%)' 
                                }, 
                                labelLine :{
                                    show:true
                                } 
                            }
                                }
                            }
                        ]
                    });
                });
            },
            drawPie2Chart() {
                this.chartPie2 = echarts.init(document.getElementById('chartPie2'));
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Statistics/CheckInElderly",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then((res) => {
                    this.chartPie2.setOption({
                        title: {
                            subtext: '',
                            x: 'center'
                        },
                        tooltip: {//提示框组件
                            trigger: 'item',//触发类型，在饼形图中为item
                            formatter: "{a} <br/>{b} : {c} ({d}%)"//提示内容格式
                        },
                        legend: {//图例
                            top: 'top',
                            data: ['60岁以下', '60-70岁', '70-80岁', '80-90岁', '90岁以上',]
                        },
                        series: [//数据系列
                            {
                                name: '套餐预约占比',
                                type: 'pie',//饼形图
                                radius: '55%',
                                center: ['50%', '60%'],
                                data: [({ 'name':'60岁以下','value':res.data.data.ageMap['60岁以下'],itemStyle:{color:"#83e067"} }),
                                        ({ 'name':'60-70岁','value':res.data.data.ageMap['60-70岁'] ,itemStyle:{color:"#87c4ec"}}),
                                        ({ 'name':'70-80岁','value':res.data.data.ageMap['70-80岁']  ,itemStyle:{color:"#e74a4a"}}),
                                        ({ 'name':'80-90岁','value':res.data.data.ageMap['80-90岁'] ,itemStyle:{color:"#ee8c1d"} }),
                                        ({ 'name':'90岁及以上','value':res.data.data.ageMap['90岁及以上'] ,itemStyle:{color:"#076fb4"} })],
                                itemStyle: {
                                    emphasis: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    },
                                    normal:{ 
                                label:{ 
                                    show: true, 
                                    formatter: '{b} : {c} ({d}%)' 
                                }, 
                                labelLine :{
                                    show:true
                                } 
                            }
                                }
                            }
                        ]
                    });
                });
                // this.chartPie2.setOption({
                //     tooltip: {
                //         trigger: 'item',
                //         formatter: "{a} <br/>{b} : {c} ({d}%)"
                //     },
                //     legend: {
                //         // orient: 'vertical',
                //         top: 'top',
                //         data: ['60岁以下', '60-70岁', '70-80岁', '80-90岁', '90岁以上',]
                //     },
                //     series: [
                //         {
                //             name: '访问来源',
                //             type: 'pie',
                //             radius: '55%',
                //             center: ['50%', '60%'],
                //             data: [
                //                 { value: 1, name: '60岁以下' ,itemStyle:{color:"#83e067"}},
                //                 { value: 4, name: '60-70岁' ,itemStyle:{color:"#87c4ec"}},
                //                 { value: 45, name: '70-80岁' ,itemStyle:{color:"#e74a4a"}},
                //                 { value: 72, name: '80-90岁' ,itemStyle:{color:"#ee8c1d"}},
                //                 { value: 20, name: '90岁以上' ,itemStyle:{color:"#076fb4"}},
                //             ],
                //             itemStyle: {
                //                 emphasis: {  
                //                     shadowBlur: 10,
                //                     shadowOffsetX: 0,
                //                     shadowColor: 'rgba(0, 0, 0, 0.5)'
                //                 },
                //                 normal:{ 
                //                 label:{ 
                //                     show: true, 
                //                     formatter: '{b} : {c} ({d}%)' 
                //                 }, 
                //                 labelLine :{
                //                     show:true
                //                 } 
                //             }
                //             }
                             
                            
                //         }
                //     ]
                // });
            },drawPie3Chart() {
                this.chartPie3 = echarts.init(document.getElementById('chartPie3'));
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Statistics/CheckInElderly",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then((res) => {
                    this.chartPie3.setOption({
                        title: {
                            subtext: '',
                            x: 'center'
                        },
                        tooltip: {//提示框组件
                            trigger: 'item',//触发类型，在饼形图中为item
                            formatter: "{a} <br/>{b} : {c} ({d}%)"//提示内容格式
                        },
                        legend: {//图例
                            top: 'top',
                            data: ['男', '女']
                        },
                        series: [//数据系列
                            {
                                name: '套餐预约占比',
                                type: 'pie',//饼形图
                                radius: '55%',
                                center: ['50%', '60%'],
                                data: [({'name':'男','value':res.data.data.sexMap.男,itemStyle:{color:"#5a97e7"}}),
                                ({ 'name':'女','value':res.data.data.sexMap.女 ,itemStyle:{color:"#f098c8"}})],
                                itemStyle: {
                                    emphasis: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    },
                                    normal:{ 
                                label:{ 
                                    show: true, 
                                    formatter: '{b} : {c} ({d}%)' 
                                }, 
                                labelLine :{
                                    show:true
                                } 
                            }
                                }
                            }
                        ]
                    });
                });
            },
            drawCharts() {
                this.drawPieChart()
                this.drawPie1Chart()
                this.drawPie2Chart()
                this.drawPie3Chart()
            },
        },
 
        mounted: function () {
            this.drawCharts()
            var that=this
            window.addEventListener("resize", () => {
                that.chartPie.resize();
                that.chartPie1.resize();
                that.chartPie2.resize();
                that.chartPie3.resize();
            });
        },
}
</script>

<style  lang="scss" scoped>
    .index {
        padding-top: 50px;
        .item{
            padding: 1vh;
            overflow: hidden;
        }
        .itemInfo{
            height: 100%;
            // border-radius:20px ;
            // border: 1 solid #e8e9ebe3;
            width: 100%;
            overflow: hidden;
            box-shadow: 0 2px 4px rgb(238, 240, 240), 0 0 6px rgb(248, 246, 246);
            background-color: #f6f7fa;
        }
        .title{
            font-size: 15px;
            color: #141414;
            margin-left: 10px;
            
            // padding-top: 1vh;
        }
        .buttoms{
            background: #cac9ca;
            border-radius:10px ;
            border: 1px solid #f0f4f7;
            text-align: center;
            line-height: 6vh;
            height: 6vh;
            margin-top: 1vh;
            color: #fff;
        }

    }
</style>